import createCrudModule from 'vuex-crud';
import {client, parseResponse} from '@/api'

export default createCrudModule({
  resource: 'faqs',
  client,
  parseSingle: parseResponse,
  parseList: parseResponse
});
